import { useRichInboxProvider } from "Domains/RichInbox/components/RichInboxProvider";
import { Box, Button, Typography } from "@material-ui/core";
import { useStyles } from "./InboxAvatar.styles";
import { observer } from "mobx-react-lite";
import React, {
  ComponentType,
  Fragment,
  useState,
} from "react";
import { ImageGalleryModal } from "Components/ImageGalleryModal";

export const InboxAvatar: ComponentType = observer(() => {
  const store = useRichInboxProvider();
  const classes = useStyles();

  const [galleyOpen, setGalleyOpen] = useState(false)

  return (
    <Fragment>
      <Typography variant="h5" paragraph>
        Inbox Avatar Image
      </Typography>
      <Typography variant="body1" paragraph>
        Inbox Post types can have an additional avatar image associated with the
        post. Images need to be 1:1 ratio and small in size.
      </Typography>
      <Box
        justifyContent="flex-start"
        alignItems="center"
        display="flex"
        width="100%"
      >
        <Box
          className={classes.media}
          justifyContent="center"
          alignItems="center"
          display="flex"
        >
          {store.post.avatarUrl ? <img src={store.post.avatarUrl} alt="avatar" />
            : (<Typography align="center" variant="body2">
              No Preview Available
            </Typography>
            )}
        </Box>
        <Box display="flex" alignItems="center" justifyContent="flex-start">
          <Button variant="outlined" component="span" onClick={() => setGalleyOpen(true)}>
            Upload Image
          </Button>
        </Box>
      </Box>
      <ImageGalleryModal
        isIcons={true}
        isOpen={galleyOpen}
        onClose={() => setGalleyOpen(false)}
        onInsertImage={(url) => store.setPost({ avatarUrl: url })
        }
      />
    </Fragment>
  );
});
